import PropTypes from 'prop-types';

import moreIcon from '../../assets/images/moreIcon.svg';
import masterCard from '../../assets/images/paymentMethod_masterCard.svg';
import mirImg from '../../assets/images/paymentMethod_mir.svg';
import visaImg from '../../assets/images/paymentMethod_visa.svg';
import styles from './styles/styles.module.css';

function BankCardItem({
  card,
  showMenu = false,
  isMenuOpen = false,
  onToggleMenu = () => {},
  onSelectOption = () => {},
  menuOptions = [],
  menuRef = null,
  isSelected = false,
  onSelectCard = null,
}) {
  let src = mirImg;
  switch (card.type) {
    case 'MIR':
      src = mirImg;
      break;
    case 'Visa':
      src = visaImg;
      break;
    case 'Mastercard':
      src = masterCard;
      break;
    default:
      src = mirImg;
      break;
  }
  return (
    <div
      className={`${styles.bankCardWrapper} ${isSelected ? styles.bankCard_selected : ''} ${onSelectCard ? styles.bankCard_onSelect : ''}`}
      role="button"
      tabIndex={0}
      ref={isMenuOpen ? menuRef : null}
      onClick={onSelectCard}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onSelectCard?.(e)}
    >
      <div className={styles.bankCardData}>
        {src ? (
          <img src={src} alt="" className={styles.bankCardLogo} />
        ) : (
          <span className={styles.bankCardNoImgContainer} />
        )}
        <p className={styles.bankCardDataText}>
          <span>****</span>
          <span>{card.last_nums}</span>
        </p>
      </div>
      <div className={styles.bankCardMoreButtonWrapper}>
        {card.default && (
          <span
            className={`${styles.bankCardBasicText} ${onSelectCard ? styles.bankCardBasicText_margin : ''}`}
          >
            Основная
          </span>
        )}
        {showMenu && (
          <button
            className={styles.bankCardMoreButton}
            onClick={() => onToggleMenu(card.id)}
          >
            <img src={moreIcon} alt="" />
          </button>
        )}
      </div>

      {showMenu && isMenuOpen && (
        <ul className={styles.dropdownMenu}>
          {menuOptions.map((option) => (
            <li key={option.value} className={styles.dropdownItem}>
              <button
                type="button"
                onClick={() => onSelectOption(option.value, card.id)}
                className={styles.dropdownButton}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default BankCardItem;

BankCardItem.propTypes = {
  card: PropTypes.shape({
    id: PropTypes.string.isRequired,
    src: PropTypes.string,
    number: PropTypes.string.isRequired,
    basic: PropTypes.bool,
    type: PropTypes.string.isRequired,
    last_nums: PropTypes.string.isRequired,
    default: PropTypes.bool,
  }).isRequired,
  showMenu: PropTypes.bool,
  isMenuOpen: PropTypes.bool,
  onToggleMenu: PropTypes.func,
  onSelectOption: PropTypes.func,
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  menuRef: PropTypes.shape({
    current: PropTypes.oneOfType([
      PropTypes.instanceOf(Element),
      PropTypes.instanceOf(null),
    ]),
  }),
  isSelected: PropTypes.bool,
  onSelectCard: PropTypes.func,
};
